import React from "react";
import GButton from "components/ui/button/Button";
import {
  Box,
  Flex,
  Stack,
  Input,
  FormControl,
  FormErrorMessage,
  FormLabel,
  useToast,
} from "@chakra-ui/react";
import GModal from "components/ui/modal/Modal";
import { useTranslation } from "react-i18next";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import {
  addNewTimeLeave,
  getLookUpTimeLeave,
} from "../../services/attendanceSettingServices";

export default function AddTimeModal({ onClose }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    trigger,
  } = useForm();
  const toast = useToast({
    position: "top",
    duration: 3000,
    status: "success",
  });
  // const toast2 = useToast({ position: "top", duration: 3000, status: "error" });

  //-------------------------------- Validation -----------------------------
  // const isOnlySpaces = (value) => {
  //   // Check if the value contains only spaces
  //   return !value.trim();
  // };

  const handleInputChange = async (e, type) => {
    setValue(type, e.target.value);
    await trigger(type);
  };
  //------------------------------------------------------------------

  return (
    <>
      <GModal
        onClose={onClose}
        modalHeader={t("pages.hr.attendance.add_new_time")}
        modalContent={
          <Box p={4}>
            <form
              onSubmit={handleSubmit((values) => {
                values.Time_ID = null;
                console.log(values);
                dispatch(addNewTimeLeave(values))
                  .unwrap()
                  .then((_) => {
                    toast({
                      description: t("pages.hr.attendance.timeLevelAdded"),
                    });
                    dispatch(getLookUpTimeLeave());
                    onClose();
                  });
              })}
            >
              <Stack spacing={6}>
                <FormControl isInvalid={errors.Time_Code}>
                  <FormLabel
                    htmlFor="Time_Code"
                    style={{ textTransform: "capitalize" }}
                  >
                    {t("pages.hr.attendance.time_code")}
                  </FormLabel>
                  <Controller
                    name="Time_Code"
                    control={control}
                    // defaultValue={"00"}
                    rules={{
                      required: t("validation.required"),
                      minLength: {
                        value: 5,
                        message: t("pages.hr.hr_validation.number_short_5"),
                      },
                      maxLength: {
                        value: 15,
                        message: t("pages.hr.hr_validation.number_long"),
                      },
                      validate: (value) => {
                        const intValue = parseInt(value, 10);
                        return (
                          intValue >= 0 || t("validation.must_be_non_negative")
                        );
                      },
                    }}
                    render={({ field }) => (
                      <Input
                        {...field}
                        placeholder={t("pages.hr.attendance.time_code")}
                        onChange={(e) => {
                          handleInputChange(e, "Time_Code");
                        }}
                        type="number"
                        min="0"
                      />
                    )}
                  />
                  <FormErrorMessage>
                    {errors.Time_Code && errors.Time_Code.message}
                  </FormErrorMessage>
                </FormControl>

                <Flex gap={4}>
                  <GButton
                    type="submit"
                    title={t("general.save")}
                    bg="primary"
                    color="light"
                    border="1px solid transparent"
                    hover={{
                      color: "primary",
                      borderColor: "primary",
                      bg: "none",
                    }}
                  />
                  <GButton
                    title={t("general.close")}
                    onClick={onClose}
                    bg="red.600"
                    border="1px solid transparent"
                    color="light"
                    hover={{
                      color: "red.600",
                      borderColor: "red.600",
                      bg: "none",
                    }}
                  />
                </Flex>
              </Stack>
            </form>
          </Box>
        }
      ></GModal>
    </>
  );
}
